import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getBrokers = async () => {
  const token = localStorage.getItem("authToken");
  const url = `get/brokers?api_password=${API_PASSWORD}`;

  const res = await api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return res.data.data;  // ← المصفوفة الصحيحة
};

export const saveBroker = async (brokerData, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `save/broker?api_password=${API_PASSWORD}`;
    const res = await api.post(url, brokerData, { headers });
    // استجابة API تحتوي عادة على { message, data } حسب الصورة — نعيد كائن الاستجابة الكامل
    return res.data;
  } catch (err) {
    // نرفع خطأ مبسّط للمستدعي لتعامل أفضل
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const editBroker = async (id = null, userId = null, brokerData = {}, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    // إذا وُفّر userId نرسل الطلب مع user_id في الـ body إلى المسار العام
    if (userId) {
      const url = `edite/broker/${userId}?api_password=${API_PASSWORD}`;
      const body = { ...brokerData, user_id: userId };
      const res = await api.post(url, body, { headers });
      return res.data;
    }

    // خلاف ذلك نستخدم السلوك القديم (id في المسار)
    const url = `edite/broker/${id}?api_password=${API_PASSWORD}`;
    const res = await api.post(url, brokerData, { headers });
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const changeBrokerStatus = async (id = null, userId = null, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    // إذا تم تزويد userId نرسل request مع user_id كـ query param
    if (userId) {
      const url = `change/status/broker/${userId}?api_password=${API_PASSWORD}`;
      const res = await api.get(url, { headers, params: { user_id: userId } });
      return res.data;
    }

    // خلاف ذلك نستخدم المسار القديم الذي يعتمد على id
    const url = `change/status/broker/${id}?api_password=${API_PASSWORD}`;
    const res = await api.get(url, { headers });
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// ================== NEW: get broker profile ==================
export const getBrokerProfile = async (userId = null, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    // بناء المسار العام مع api_password
    let url = `broker/profile?api_password=${API_PASSWORD}`;
    if (userId) url += `&user_id=${userId}`;

    const res = await api.get(url, { headers });
    // ✅ نعيد الكائن داخل data.data مباشرة (كباقي الدوال)
    return res.data.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// ================== NEW: get broker pending requests ==================
export const getBrokerPendingRequests = async (userId = null, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let url = `broker/get/pending/requests?api_password=${API_PASSWORD}`;
    if (userId) url += `&user_id=${userId}`;

    const res = await api.get(url, { headers });
    // نعيد مصفوفة الطلبات المعلقة
    return res.data.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const getBrokerTenants = async (userId = null, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let url = `broker/get/tenants?api_password=${API_PASSWORD}`;
    if (userId) url += `&user_id=${userId}`;

    const res = await api.get(url, { headers });
    // نعيد المصفوفة داخل data (نفس نمط الدوال الأخرى)
    return res.data.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const getBrokerCustomers = async (userId = null, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let url = `broker/customers?api_password=${API_PASSWORD}`;
    if (userId) url += `&user_id=${userId}`;

    const res = await api.get(url, { headers });
    // نعيد المصفوفة داخل data (نفس نمط getBrokers)
    return res.data.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const getBrokerAccounts = async (userId = null, token = null) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let url = `broker/get/accounts?api_password=${API_PASSWORD}`;
    if (userId) url += `&user_id=${userId}`;

    const res = await api.get(url, { headers });
    // نعيد مصفوفة الحسابات من data
    return res.data.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة المطلوبة: تغيير حالة الـ Tenant (إرسال tenant_id كـ form-data)
export const changeTenantStatus = async (tenantId, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/change/tenant/status?api_password=${API_PASSWORD}`;

    // استخدام FormData لأن الـ endpoint يتوقع form-data كما في الصورة
    const formData = new FormData();
    formData.append("tenant_id", tenantId);

    // تأكد من override الـ Content-Type إلى multipart/form-data
    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    // إعادة الاستجابة الكاملة (قد تحتوي message فقط كما في المثال)
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: إضافة ميزة لِـ tenant عبر form-data
export const addFeatureToTenant = async (tenantId, payload = {}, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/add/feature/to/tenant/${tenantId}?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    if (payload.feature_id != null) formData.append("feature_id", payload.feature_id);
    if (payload.value != null) formData.append("value", payload.value);
    if (payload.yearly_cost != null) formData.append("yearly_cost", payload.yearly_cost);
    if (payload.monthly_cost != null) formData.append("monthly_cost", payload.monthly_cost);
    if (payload.start_date != null) formData.append("start_date", payload.start_date);
    if (payload.end_date != null) formData.append("end_date", payload.end_date);

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const getAllFeatures = async () => {
  const token = localStorage.getItem("authToken");
  const response = await api.get(`/broker/get/featuers?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return response.data; // ✅ بدل ما ترجع response كله
};

// إضافة الدالة: تحديث ميزة لِـ tenant عبر form-data
export const updateFeatureToTenant = async (tenantId, featureId, payload = {}, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    // مسار مشابه لإضافة الميزة لكن مع featureId في المسار (مطابق للصورة)
    const url = `broker/update/feature/to/tenant/${tenantId}/${featureId}?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    // حقول محتملة — أضف فقط إن وُجدت في payload
    if (payload.value != null) formData.append("value", payload.value);
    if (payload.yearly_cost != null) formData.append("yearly_cost", payload.yearly_cost);
    if (payload.monthly_cost != null) formData.append("monthly_cost", payload.monthly_cost);
    if (payload.start_date != null) formData.append("start_date", payload.start_date);
    if (payload.end_date != null) formData.append("end_date", payload.end_date);

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: إنشاء حساب بروكر (form-data)
export const createBrokerAccount = async (accountData = {}, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/create/account?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    // الحقول المتوقعة (أضف أو غيّر حسب حاجة الـ API)
    if (accountData.email != null) formData.append("email", accountData.email);
    if (accountData.password != null) formData.append("password", accountData.password);
    if (accountData.name != null) formData.append("name", accountData.name);
    if (accountData.phone != null) formData.append("phone", accountData.phone);
    // إضافة أية حقول إضافية إن وُجدت
    Object.keys(accountData || {}).forEach((k) => {
      if (["email", "password", "name", "phone"].includes(k)) return;
      const v = accountData[k];
      if (v != null) formData.append(k, v);
    });

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: تعديل حساب بروكر عبر form-data
export const editBrokerAccount = async (accountId, accountData = {}, token = null) => {
  if (!accountId) throw new Error("accountId مطلوب");
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/edite/account/${accountId}?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    if (accountData.email != null) formData.append("email", accountData.email);
    if (accountData.password != null) formData.append("password", accountData.password);
    if (accountData.name != null) formData.append("name", accountData.name);
    if (accountData.phone != null) formData.append("phone", accountData.phone);
    if (accountData.active != null) formData.append("active", String(accountData.active));
    // أضف أي حقول إضافية متاحة في accountData
    Object.keys(accountData || {}).forEach((k) => {
      if (["email", "password", "name", "phone", "active"].includes(k)) return;
      const v = accountData[k];
      if (v != null) formData.append(k, v);
    });

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: رفض طلب ديمو (GET) بواسطة معرف الطلب
export const rejectDemoRequest = async (requestId, token = null) => {
  if (!requestId) throw new Error("requestId مطلوب");
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/reject/demo/request/${requestId}?api_password=${API_PASSWORD}`;
    const res = await api.get(url, { headers });
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: قبول (الموافقة على) طلب ديمو عبر form-data (POST)
export const acceptDemoRequest = async (requestId, payload = {}, token = null) => {
  if (!requestId) throw new Error("requestId مطلوب");
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/accepted/demo/${requestId}?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    // الحقول المتوقعة حسب الصورة: start_demo, end_demo, cost, notes
    if (payload.start_demo != null) formData.append("start_demo", payload.start_demo);
    if (payload.end_demo != null) formData.append("end_demo", payload.end_demo);
    if (payload.cost != null) formData.append("cost", payload.cost);
    if (payload.notes != null) formData.append("notes", payload.notes);
    // أضف أي حقول إضافية إن لزم
    Object.keys(payload || {}).forEach((k) => {
      if (["start_demo", "end_demo", "cost", "notes"].includes(k)) return;
      const v = payload[k];
      if (v != null) formData.append(k, v);
    });

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: تفعيل نسخة تجريبية لِـ tenant عبر form-data (POST)
// متوقع الحقول: start_date, end_date, plane_id, tenant_id (وأي حقول إضافية)
export const activateDemoToTenant = async (payload = {}, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/active/demo/to/tenant?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    if (payload.start_date != null) formData.append("start_date", payload.start_date);
    if (payload.end_date != null) formData.append("end_date", payload.end_date);
    if (payload.plane_id != null) formData.append("plane_id", payload.plane_id);
    if (payload.tenant_id != null) formData.append("tenant_id", payload.tenant_id);
    // أضف أية حقول إضافية إن وُجدت في payload
    Object.keys(payload || {}).forEach((k) => {
      if (["start_date", "end_date", "plane_id", "tenant_id"].includes(k)) return;
      const v = payload[k];
      if (v != null) formData.append(k, v);
    });

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: تجديد نظام بروكر عبر form-data (POST)
// متوقع الحقول: tenant_id, cost, renew_date, notes, employee_name, start_date, end_date, file
export const renewBrokerSystem = async (payload = {}, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/renew/system?api_password=${API_PASSWORD}`;

    const formData = new FormData();
    if (payload.tenant_id != null) formData.append("tenant_id", payload.tenant_id);
    if (payload.cost != null) formData.append("cost", payload.cost);
    if (payload.renew_date != null) formData.append("renew_date", payload.renew_date);
    if (payload.notes != null) formData.append("notes", payload.notes);
    if (payload.employee_name != null) formData.append("employee_name", payload.employee_name);
    if (payload.start_date != null) formData.append("start_date", payload.start_date);
    if (payload.end_date != null) formData.append("end_date", payload.end_date);
    if (payload.file != null) formData.append("file", payload.file);
    // أضف أية حقول إضافية إن وُجدت في payload
    Object.keys(payload || {}).forEach((k) => {
      if (["tenant_id", "cost", "renew_date", "notes", "employee_name", "start_date", "end_date", "file"].includes(k)) return;
      const v = payload[k];
      if (v != null) formData.append(k, v);
    });

    const res = await api.post(url, formData, {
      headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

export const getAllDemoRequests = async () => {
  const token = localStorage.getItem("authToken");
  const response = await api.get(`/broker/all/demo/request?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return response.data; // ✅ بدل ما ترجع response كله
};

export const deleteDemoRequest = async (requestId, token = null) => {
  if (!requestId) throw new Error("requestId مطلوب");
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const url = `broker/delete/demo/request/${requestId}?api_password=${API_PASSWORD}`;
    const res = await api.get(url, { headers });
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: حذف ميزة من tenant (GET)
export const deleteFeatureFromTenant = async (tenantId, featureId, token = null) => {
  if (!tenantId) throw new Error("tenantId مطلوب");
  if (featureId == null || featureId === "") throw new Error("featureId مطلوب");
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    // المسار مطابق للصورة: /broker/delete/feature/to/tenant/{tenant}/{featureId}/?api_password=...
    const url = `broker/delete/feature/to/tenant/${tenantId}/${featureId}?api_password=${API_PASSWORD}`;
    const res = await api.get(url, { headers });
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};

// إضافة الدالة: إنشاء نسخة (version) لمستخدم بواسطة form-data (POST)
// export const createVersionToUser = async (payload = {}, token = null) => {
//   try {
//     const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};
//     const url = `broker/create/version?api_password=${API_PASSWORD}`;

//     const formData = new FormData();
//     // حقول بسيطة
//     if (payload.domain != null) formData.append("domain", payload.domain);
//     if (payload.user_id != null) formData.append("user_id", payload.user_id);
//     if (payload.plane_id != null) formData.append("plane_id", payload.plane_id);
//     if (payload.cost != null) formData.append("cost", payload.cost);
//     if (payload.start_date != null) formData.append("start_date", payload.start_date);
//     if (payload.end_date != null) formData.append("end_date", payload.end_date);

//     // دعم مصفوفة الميزات features: [{ feature_id, value, yearly_cost, monthly_cost, start_date, end_date }, ...]
//     if (Array.isArray(payload.features)) {
//       payload.features.forEach((f, i) => {
//         if (f.feature_id != null) formData.append(`features[${i}][feature_id]`, f.feature_id);
//         if (f.value != null) formData.append(`features[${i}][value]`, f.value);
//         if (f.yearly_cost != null) formData.append(`features[${i}][yearly_cost]`, f.yearly_cost);
//         if (f.monthly_cost != null) formData.append(`features[${i}][monthly_cost]`, f.monthly_cost);
//         if (f.start_date != null) formData.append(`features[${i}][start_date]`, f.start_date);
//         if (f.end_date != null) formData.append(`features[${i}][end_date]`, f.end_date);
//       });
//     }

//     // أي حقول إضافية أخرى ضمن payload يتم إضافتها تلقائياً (عدا الحقول المسبقة)
//     const skip = new Set(["domain","user_id","plane_id","cost","start_date","end_date","features"]);
//     Object.keys(payload || {}).forEach((k) => {
//       if (skip.has(k)) return;
//       const v = payload[k];
//       if (v == null) return;
//       // تجنب إضافة كائنات/مصفوفات معقدة بشكل مباشر
//       if (typeof v === "object") return;
//       formData.append(k, v);
//     });
// console.log("FormData entries:", Array.from(formData.entries()));
//     const res = await api.post(url, formData, {
//       headers: { ...headersAuth, "Content-Type": "multipart/form-data" },
//     });

//     return res.data;
//   } catch (err) {
//     if (err.response && err.response.data) throw err.response.data;
//     throw err;
//   }
// };

export const createVersionToUser = async (payload = {}, token = null) => {
  try {
    const headersAuth = token ? { Authorization: `Bearer ${token}` } : {};

    const url = `broker/create/version?api_password=${API_PASSWORD}`;

    const res = await api.post(url, payload, {
      headers: {
        ...headersAuth,
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
    });

    return res.data;

  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
};
